/* istanbul ignore file */
import React from 'react';
import { EnumField, FieldProps } from 'framework/ui/field';
import { ASSET_CONDITIONS } from 'domain/finance/assets/useAssetService';

const AssetConditionField = (props: FieldProps) => {
  return <EnumField options={ASSET_CONDITIONS} {...props} />;
};

export default AssetConditionField;
